import 'primereact/resources/themes/lara-light-indigo/theme.css'; // Replace 'bootstrap' with the desired theme name
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import 'primeflex/themes/primeone-dark.css';
import React, { useState, useEffect, useRef } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Tag } from 'primereact/tag';
import { Toast } from 'primereact/toast';
import _ from "lodash";
import { isMobile } from "react-device-detect";
import Services from "./GrievanceService";
import AUX from "../../hoc/Aux_";
import GrievanceHeader from "./General/GrievanceHeader";
import { PdfDocument } from "../../modules/Grievances/General/GrievanceStepPDF";
import { PDFDownloadLink } from "@react-pdf/renderer";
import { Col } from 'react-bootstrap';

export default function GrievanceListing() {
    const [grievanceList, setGrievanceList] = useState([]);
    const [expandedRows, setExpandedRows] = useState({});
    const [loading, setLoading] = useState(false);
    const [selectedGrievances, setselectedGrievances] = useState(null);
    const [rowClick, setRowClick] = useState(true);
    const [activeTab, setActiveTab] = useState(1);
    const [globalFilter, setGlobalFilter] = useState(null);
    const [groupedData, setGroupedData] = useState(null);

    const toast = useRef(null);

    useEffect(() => {
        loadAllRequests();
    }, []);

    useEffect(() => {
        if (grievanceList.length > 0) {
            const initialExpandedRows = grievanceList.map(() => false); // create an array with the same length as grievanceList filled with 'false'
            initialExpandedRows[grievanceList[0].grievanceId] = true; // set the first row to 'true'
            setExpandedRows(initialExpandedRows);
        }
    }, [grievanceList]);

    const loadAllRequests = () => {
        setLoading(true);
        let grievancesList = [];
        Services.LoadAllGrievances(true).then((result) => {
            if (!_.isEmpty(result.data)) {
                debugger;

                _.forEach(result.data, function (el, index, arr) {
                    grievancesList.push({
                        dateFiled: el.dateFiled,
                        facilityId: el.facilityId,
                        facility: isMobile ? el.facilityCode : el.facilityName,
                        grievanceId: el.grievanceId,
                        region: el.regionName,
                        assignedUserName: el.assignedUserName,
                        assignedGRTUserName: el.assignedGRTUserName,
                        assignedGRTUserId: el.assignedGRTUserId,
                        assignedUserId: el.assignedUserId,
                        articleName: el.articleName,
                        articleId: el.articleId,
                        gId: el.id,
                        grievant: el.grievantName,
                        regionId: el.regionId,
                        status: el.status,
                        step: el.step,
                        canEdit: el.canEdit,
                        representativeName: el.representativeName,
                        subject: el.grievanceSubject,
                        remainingDays: parseInt(el.daysRemainingForNextDueDate),
                    });
                });

                const groupedData = (result.data || []).reduce((groups, item) => {
                    const group = (groups[item.status] || []);
                    group.push(item);
                    groups[item.status] = group;
                    return groups;
                }, {});

                setGroupedData(groupedData);
                console.log(groupedData);
                setGrievanceList(grievancesList);
                setLoading(false);
            }

        });
    }

    const remainingDaysBodyTemplate = (rowData) => {
        if (!rowData.daysRemainingForNextDueDate) return 'No Record';
        var remainValue = parseInt(rowData.daysRemainingForNextDueDate + 3) + ' Days';
        return <Tag value={remainValue} severity={getRemainingDaysSeverity(rowData)}></Tag>;
    };


    const dateBodyTemplate = (rowData) => {
        return formatDate(rowData.dateFiled);
    };

    const onRowExpand = (event) => {
        setExpandedRows(prevState => ({ ...prevState, [event.data.status]: true }));
    };

    const onRowCollapse = (event) => {
        setExpandedRows(prevState => ({ ...prevState, [event.data.status]: false }));
    };


    const formatDate = (value) => {
        if (value) {
            const dateString = value;
            const dateObject = new Date(dateString);
            const day = dateObject.getDate();
            const month = dateObject.getMonth() + 1;
            const year = dateObject.getFullYear();
            const formattedDate = `${month.toString().padStart(2, '0')}/${day.toString().padStart(2, '0')}/${year}`;
            return formattedDate;

        } else {
            return '';
        }
    };

    const getRemainingDaysSeverity = (grievance) => {
        const days = parseInt(grievance.daysRemainingForNextDueDate + 3);
        var severity = '';
        if (days < 5) {
            severity = 'danger';
        }
        else if (days < 10) {
            severity = 'warning';
        }
        return severity;
    };

    const handleDuplicateClick = (rowData, e) => {
        e.preventDefault();
        e.nativeEvent.stopImmediatePropagation();
    };

    const actionBodyTemplate = (rowData) => {
        return (
            <div>
                <PDFDownloadLink
                    onClick={(e) => {
                        e.preventDefault();
                        e.nativeEvent.stopImmediatePropagation();
                    }}
                    document={<PdfDocument data={rowData.pdfData} />}
                    fileName={rowData.gId + ".pdf"}
                >
                    <Button rounded title='Download PDF' icon="pi pi-file-pdf" className="p-button-success" />
                </PDFDownloadLink>
                <Button rounded title='Duplicate Grievance' icon="pi pi-copy" style={{ marginLeft: '5px' }} className="p-button-info ml-8" onClick={() => handleDuplicateClick(rowData)} />
            </div>
        );
    };

    const rowExpansionTemplate = (rowData) => {
        return (
            <DataTable value={rowData.data} sortMode="multiple" stripedRows selection={selectedGrievances} onSelectionChange={(e) => setselectedGrievances(e.value)}>
                <Column selectionMode="multiple" headerStyle={{ width: '3rem' }}></Column>
                <Column sortable field="grievantName" header="Grievant" />
                <Column sortable field="dateFiled" header="Date Filed" />
                <Column sortable field="regionName" header="Region" />
                <Column sortable field="facilityName" header="Facility" />
                <Column sortable field="step" header="Step" />
                <Column sortable field="grievanceSubject" header="Subject" />
                <Column sortable field="representativeName" header="Representative" />
                <Column sortable field="articleName" header="Contract Article" />
                <Column sortable field="daysRemainingForNextDueDate" body={remainingDaysBodyTemplate} header="Remaining Days" />
                <Column sortable field="id" header="ID" />
                <Column body={actionBodyTemplate} />
            </DataTable>
        );
    };



    const header = (
        <div className="flex flex-wrap gap-2 align-items-center ">
            <span className="p-input-icon-left">
                <i className="pi pi-search" />
                <InputText type="search" onInput={(e) => setGlobalFilter(e.target.value)} placeholder="Search..." />
            </span>
        </div>
    );

    return (
        <AUX>
            <GrievanceHeader
                changeActiveTab={setActiveTab}
                ActiveTab={activeTab}
            />
            <div className="pac-container container-fluid">
                <div className="row">
                    <div className='col-md-12'>
                        <Toast ref={toast} />

                        {groupedData ? (
                            <DataTable
                                value={Object.entries(groupedData).map(([status, data]) => ({ status, data }))}
                                rowExpansionTemplate={rowExpansionTemplate} dataKey="status"
                                globalFilter={globalFilter} header={header} globalFilterFields={['grievant', 'region', 'facility', 'step', 'representativeName']}
                                scrollable resizableColumns showGridlines size='small' loading={loading} selectionMode={rowClick ? null : 'checkbox'}

                                onRowToggle={(e) => setExpandedRows(e.data)}
                                tableStyle={{ minWidth: '50rem' }}
                                expandedRows={expandedRows} onRowExpand={onRowExpand} onRowCollapse={onRowCollapse} // add these lines
                            >
                                <Column expander style={{ width: '3em' }} />
                                <Column field="status" header="Status" />
                            </DataTable>
                        ) : (
                            <div>Loading...</div>  // or some sort of spinner or alternative content
                        )}

                    </div>
                </div>
            </div>
        </AUX>
    );
}
